"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer2 from "@/components/landing-page/Footer2";

export default function TermsPage() {
    return (
        <>
            <Navbar isLoggedIn={false} />
            <div className="bg-zinc-950 min-h-screen text-white pt-32 pb-20">
                <div className="max-w-3xl mx-auto px-6">
                    <h1 className="text-3xl md:text-4xl font-bold mb-8">Terms of Service</h1>
                    <div className="prose prose-invert prose-zinc text-zinc-400">
                        <p className="text-sm text-zinc-500 mb-8">Last Updated: January 1, 2026</p>

                        <h3>1. Introduction</h3>
                        <p>Welcome to Senera Core. By accessing our website and using our services, you agree to comply with and be bound by the following terms and conditions.</p>

                        <h3>2. Use of Service</h3>
                        <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for all activity that occurs under your account.</p>

                        <h3>3. Intellectual Property</h3>
                        <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Senera Core Inc and its licensors.</p>

                        <h3>4. Termination</h3>
                        <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>

                        <h3>5. Limitation of Liability</h3>
                        <p>In no event shall Senera Core, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages.</p>

                        <h3>6. Changes</h3>
                        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time.</p>
                    </div>
                </div>
            </div>
            <Footer2 />
        </>
    );
}
